import React, { useState } from "react";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Chip,
    Typography
} from "@mui/material/";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { strings } from "../../../../../common/i18n";
import NoteInput from "./NoteInput";
import AssetDetail from "../../AssetDetail";
import AssetAuditors from "../AssetAuditors";
import styles from "../styles";
import ExclusionComponent from "./ExclusionComponent";
import NonMandatoryReason from "./NonMandatoryReason";
import useAssetFoundElseWhere from "./useAssetFoundElseWhere";
import { useDispatch } from "react-redux";
import actions from "../../../../../Store/actions";
import { logToSentry } from "../../../../../config/Sentry";

/**
 * Left Layout Component
 */

export default ({
    assetAuditor,
    setAssetAuditor,
    data,
    exclusionReason,
    setExclusionReason,
    exclusionNote,
    historyNote,
    setNoteType,
    setExclusionNote,
    setHistoryNote,
    onExclusionSubmit,
    onHistorySubmit,
    exclusionDatePicker,
    handleDateChange,
    selectedDate
}) => {
    /** Accordion Changes */
    const [expanded, setExpanded] = useState({
        panel1: true,
        panel2: true
    });
    const dispatch = useDispatch();
    const foundElsewhere = useAssetFoundElseWhere();

    /** On accordion Change */
    const handleAccordionChange = (panel) => () => {
        try {
            if (panel.length > 0) {
                setExpanded((prevState) => ({
                    ...prevState,
                    [panel]: !prevState[panel]
                }));
            }
        } catch (error) {
            const errStr = error.toString();
            console.error(errStr);
            logToSentry("On accordion change:", { error });
            dispatch(
                actions.toast.create.error(strings("errors.onAccordionChange"))
            );
        }
    };

    return (
        <>
            {data &&
                typeof data.isMandatory === "boolean" &&
                data.isMandatory === false && (
                    <Box sx={styles.nonMandatoryAssetPageBanner}>
                        <Typography variant="subtitle2">
                            {strings("messages.nonMandatoryAssetBanner")}
                        </Typography>
                        <NonMandatoryReason reason={data.nonMandatoryReason} />
                    </Box>
                )}
            <Accordion
                expanded={expanded.panel1}
                sx={styles.accordionContainer}
                onChange={handleAccordionChange("panel1")}
            >
                <AccordionSummary
                    expandIcon={expanded.panel1 ? <RemoveIcon /> : <AddIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                    sx={styles.accordionHeader}
                >
                    <Typography variant="body1">
                        {strings("assetDetails")}
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <AssetDetail
                        asset={data.asset}
                        attributes={data.asset.attributes}
                    />
                </AccordionDetails>
            </Accordion>
            <>
                <Accordion
                    sx={styles.accordionContainer}
                    expanded={expanded.panel2}
                    onChange={handleAccordionChange("panel2")}
                >
                    <AccordionSummary
                        expandIcon={
                            expanded.panel2 ? <RemoveIcon /> : <AddIcon />
                        }
                        aria-controls="panel2a-content"
                        id="panel2a-header"
                        sx={styles.accordionHeader}
                    >
                        <Typography variant="body1">
                            {strings("history")}
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails
                        sx={styles.accordionDetails}
                        style={{ p: 0 }}
                    >
                        <Box
                            sx={{
                                flex: 1,
                                overflowY: "auto",
                                px: 2,
                                py: 1
                            }}
                        >
                            <AssetAuditors
                                auditAssetId={data.id}
                                onValueChange={setAssetAuditor}
                                value={assetAuditor}
                            />
                        </Box>
                        <Box
                            sx={{
                                px: 2,
                                py: 1.5,
                                backgroundColor: "#fff",
                                borderTop: "1px solid #e0e0e0",
                                boxShadow: "0 -2px 8px rgba(0,0,0,0.05)",
                                position: "sticky",
                                bottom: 0
                            }}
                        >
                            <NoteInput
                                setNoteType={setNoteType}
                                historyNote={historyNote}
                                setHistoryNote={setHistoryNote}
                                onSubmit={onHistorySubmit}
                            />
                        </Box>
                    </AccordionDetails>
                </Accordion>

                {(data?.assetRejection?.length > 0 ||
                    data?.isAssigned ||
                    foundElsewhere) && (
                    <ExclusionComponent
                        exclusionNote={exclusionNote}
                        setExclusionNote={setExclusionNote}
                        exclusionReason={exclusionReason}
                        setExclusionReason={setExclusionReason}
                        onExclusionSubmit={onExclusionSubmit}
                        setNoteType={setNoteType}
                        exclusionDatePicker={exclusionDatePicker}
                        handleDateChange={handleDateChange}
                        selectedDate={selectedDate}
                        type="left"
                    />
                )}
            </>
        </>
    );
};
